export default function SideBar(props) {
    return (
        <>
            <div className="bottom-footer">
                 <p className="m-0">@Copyright 2024</p>
            </div>
        </>
    );
}